<div class="bp-modal mod-lg">
  <bp-modal-header
		[title]="
			currentStep !== 4
				? ('security_settings_2fa_disable_modal_title' | translate)
				: ('security_settings_2fa_disable_modal_step_success_popup_title' | translate)
		">
    <a right (click)="closeAll()" (keydown.enter)="closeAll()" [tabIndex]="0">
      <strong>{{ "close" | translate }}</strong>
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section mod-wide pt-25 min-h-400">
      <!-- Step 1 - Enter Password &  Enter verification code -->
      @if (currentStep === 1) {
        <div>
          <div class="center-block max-w-550 text-center description-text mt-40">
            {{ "security_settings_2fa_disable_modal_step_password_description" | translate }}
          </div>
          <div class="center-block max-w-468 mt-40">
            <p class="mb-5 description-input-text">
              {{ "security_settings_2fa_disable_modal_step_password_input_title" | translate }}
            </p>
            <div class="max-w-468">
              <div
                class="form-group"
							[ngClass]="{
								'has-error': passwordError?.getValidationError('password')
							}">
                <input
                  #loginpwd
                  [type]="'password'"
                  class="form-field"
                  id="password"
                  [(ngModel)]="passInput"
                  (ngModelChange)="passwordError = null"
                  name="password"
                  autofocus
                  placeholder="{{ 'security_settings_2fa_enable_modal_step_enter_password' | translate }}"
                  required />
                @if (passwordError?.getValidationError('password')) {
                  <div
                    class="form-error has-error align-left">
                    {{ passwordError?.getValidationError("password") }}
                  </div>
                }
              </div>
            </div>
            <p class="mb-5 description-input-text mt-30">
              {{ "security_settings_2fa_disable_modal_step_2fa_input_title" | translate }}
            </p>
            <div class="max-w-468">
              <bp-input
                [type]="'text'"
                class="code-input-class"
                [maxlength]="6"
                [showCharCounter]="false"
                [(value)]="verifyCodeInputValue"
                [error]="authCodeError?.getValidationError('auth_code') | translate"
                (valueChange)="authCodeError = null"
							[placeholder]="
								'security_settings_2fa_enable_modal_step_input_pin_code_placeholder' | translate
							"
              autofocus></bp-input>
            </div>
          </div>
        </div>
      }
      <!-- Step 2 - SMS Verification -->
      @if (currentStep === 2) {
        <div>
          <verification-sms-code
            #smsPinInput
            (pinSent)="setSmsCode($event)"
            [password]="passInput"
          [codeLength]="4"></verification-sms-code>
        </div>
      }
      <!-- Step 3 - Successfully deactivated -->
      @if (currentStep === 3) {
        <div>
          <div class="center-block max-w-550 text-center">
            <div class="success-symbol mod-orange mb-20 mt-70 center-block">
              <span class="bpi__icon-close"></span>
            </div>
            <h2 class="mt-20 max-w-468 center-block text-center">
              {{ "security_settings_2fa_disable_modal_step_success_title" | translate }}
            </h2>
            <p class="mb-15 mt-20 description-text">
              {{ "security_settings_2fa_disable_modal_step_success_description" | translate }}
            </p>
          </div>
          <button class="btn btn-primary center-block text-center mt-30 min-w-135" (click)="onClickContinue()">
            {{ "security_settings_2fa_enable_modal_step_success_button" | translate }}
          </button>
          <a class="center-block text-center mt-30 mb-70" (click)="onClickReEnable()">
            {{ "security_settings_2fa_disable_modal_step_success_re_enable" | translate }}
          </a>
        </div>
      }
    </div>
    @if (currentStep !== 3) {
      <div class="modal-footer-2fa">
        @if (currentStep === 1) {
          <button
            class="btn btn-primary full-width-button"
            (click)="onClickContinue()"
            [disabled]="!verifyCodeInputValue">
            {{ "security_settings_2fa_disable_modal_button_disable" | translate }}
          </button>
        }
        @if (currentStep === 2) {
          <button
            class="btn btn-primary full-width-button"
            (click)="onClickContinue()"
            [disabled]="!smsCode">
            {{ "security_settings_2fa_disable_modal_button_disable" | translate }}
          </button>
        }
      </div>
    }
  </div>
</div>
